import React, { useEffect, useState } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import { Box, ThemeProvider } from '@mui/material'
import { AppDefaultTheme } from '../themes/AppDefaultTheme'
import BannerHero from '../components/interfaces/BannerHero'
import MissionStatement from '../components/interfaces/MissionStatement'
import ContactForm from '../components/interfaces/ContactForm'
import GridRomance from '../components/interfaces/GridRomance'
import BannerCustom from '../components/interfaces/BannerCustom'
import AppFeatures from '../components/interfaces/AppFeatures'

const AppNavigator = (props) => {

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  return (
    <>
    <ThemeProvider theme={AppDefaultTheme}>
      <Header width={width} />
      <BannerHero width={width} />
      <MissionStatement />
      <Box sx={{my: 5,}}>
        <GridRomance />
      </Box>
      <BannerCustom />
      <Box sx={{mt: 5,}}>
        <AppFeatures />
      </Box>
      <Box sx={{mt:5,}}>
        <ContactForm />
      </Box>
      <Footer />
    </ThemeProvider>
    </>
  )
}

export default AppNavigator